module.exports = __webpack_public_path__ + "static/media/default-img.22d55e33.png";